import { createRoutine } from "redux-saga-routines";

export const loadTopVideos = createRoutine("STATISTICS/LOAD_TOP_VIDEOS");
export const loadTopUsers = createRoutine("STATISTICS/LOAD_TOP_USERS");
export const loadVideoInfoByMediaId = createRoutine("STATISTICS/LOAD_VIDEO_INFO_BY_MEDIA_ID");
